export default "__VITE_ASSET__cec3141a__"